
import Header from "../Header";
import SideMenu from "../SideMenu";
import { Toaster } from "../ui/toaster";
import { ReactNode, useState } from "react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

interface DashboardProps {
  children: ReactNode;
}

const DashboardLayout = ({ children }: DashboardProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div id="container" className="flex h-screen bg-[#eef1fa] relative">
      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Mobile Menu Button */}
      <button
        onClick={toggleMobileMenu}
        className="fixed top-4 left-4 z-50 p-2 bg-slate-800 rounded-lg text-white md:hidden"
        aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
        aria-expanded={isMobileMenuOpen}
        title={isMobileMenuOpen ? "Close menu" : "Open menu"}
      >
        {isMobileMenuOpen ? (
          <XMarkIcon className="h-6 w-6" />
        ) : (
          <Bars3Icon className="h-6 w-6" />
        )}
      </button>

      {/* Sidebar */}
      <div className={`
        fixed md:static top-0 left-0 bottom-0 z-40 p-2
        transform transition-transform duration-300 ease-in-out
        ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
        md:w-48 lg:w-52 xl:w-56
      `}>
        <div data-tour="dashboard-start" className="h-full w-48 md:w-full">
          <SideMenu />
        </div>
      </div>
      
      {/* Main Content Area */}
      <div className="flex-1 md:ml-0 overflow-y-auto">
        <div className="py-3 px-4 md:px-6 lg:px-8 min-h-full flex flex-col">
          <div className="ml-0 md:ml-0">
            <Header />
          </div>
          <div className="flex-1 pb-4 mt-4 md:mt-0">
            {children}
          </div>
          <Toaster />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;